import { FC } from 'react'

import { LoadingIcon } from 'components/shared/Icons'

type LoadingScreenProps = {
  isLoading?: boolean
}

const LoadingScreen: FC<LoadingScreenProps> = ({ isLoading = true }) => {
  return (
    <>
      {isLoading ? (
        <div>
          <div className='fixed inset-0 bg-white z-top'></div>
          <div
            className='flex flex-col items-center justify-center backdrop'
            style={{ zIndex: 9999 }}
          >
            <span className='text-4xl text-primary-purple animate-spin'>
              <LoadingIcon />
            </span>
            <span className='mt-8 font-semibold text-primary-purple'>
              Loading...
            </span>
          </div>
        </div>
      ) : null}
    </>
  )
}

const PageLoading: FC = () => {
  return (
    <div className='relative w-full h-[var(--content-height)] flex items-center justify-center'>
      <span className='relative inline-block text-4xl animate-spin text-primary-purple'>
        <LoadingIcon />
      </span>
    </div>
  )
}

export default LoadingScreen
export { PageLoading }
